import { get } from '.';
import qs from 'qs';

export const getTravelDiarySettings = ({ filters, skip } = {}) => {
  if (skip) {
    return Promise.resolve(null);
  }
  return get(`/api/v1/travel-diaries/settings?${qs.stringify(filters)}`);
};
